import type { Percentage } from "@@/shared/percentage";
import type { Price} from "./price";
import { priceFactory } from "./price";

const updateVat =
    (percent: Percentage) =>
    (originalPrice: Price, newVat?: Percentage): Price => {
        const _newVat = newVat ?? originalPrice.vat;
        const newAmountExcludingVat =
            originalPrice.amountExcludingVat * percent;
        const newAmountIncludingVat =
            newAmountExcludingVat * (_newVat ?? originalPrice.vat);
        return priceFactory({
            currencyCode: originalPrice.currencyCode,
            tags: originalPrice.tags,
            vat: _newVat,
            amountIncludingVat: newAmountIncludingVat,
        });
    };

export { updateVat };
